module.exports = __webpack_public_path__ + "media/Audio21.ce53f401.wav";